import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import { colors, radius } from '../theme';

export default function ForgotPassword({ open, handleClose }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: (e) => { e.preventDefault(); handleClose(); },
                    sx: {
                        backgroundImage: 'none',
                        bgcolor:        colors.bgCard,
                        border:         `1px solid ${colors.border}`,
                        borderRadius:   radius.lg,
                        color:          colors.textPrimary,
                    },
                },
            }}
        >
            <DialogTitle sx={{ color: colors.textPrimary, fontFamily: "'Playfair Display', serif" }}>
                Reset password
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                <DialogContentText sx={{ color: colors.textFaint, fontSize: 13 }}>
                    Enter your account's email address, and we'll send you a link to reset your password.
                </DialogContentText>
                <OutlinedInput
                    autoFocus required margin="dense"
                    id="email" name="email"
                    placeholder="Email address"
                    type="email" fullWidth
                    sx={{
                        bgcolor:      colors.bgDeep,
                        borderRadius: radius.md,
                        color:        colors.textPrimary,
                        fontSize:     13,
                        '& fieldset':              { borderColor: colors.border },
                        '&:hover fieldset':        { borderColor: colors.primaryBorder },
                        '&.Mui-focused fieldset':  { borderColor: colors.primary },
                        '& input':                 { color: colors.textPrimary },
                        '& input::placeholder':    { color: colors.textFaintest, opacity: 1 },
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3, gap: 1 }}>
                <Button onClick={handleClose}
                    sx={{ color: colors.textFaint, textTransform: 'none', '&:hover': { color: colors.textPrimary } }}>
                    Cancel
                </Button>
                <Button variant="contained" type="submit"
                    sx={{ bgcolor: colors.primary, color: colors.bg, fontWeight: 700, textTransform: 'none', borderRadius: radius.md, '&:hover': { bgcolor: colors.primaryHover } }}>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}